jQuery(function($){
	$(".widget-attr .form-check-input").change(function() {
		var list_slug = [];
		var list_selected = [];
		$('.widget-attr :checked').each(function() {
			list_slug.push($(this).attr('data-type'));
			list_selected.push($(this).attr('data-label'));
		});
		data = {
			'action': 'filter',
			'query': filter_params.posts,
			'page' : filter_params.current_page,
			'list_slug' : list_slug,
		};
		$.ajax({
			url : filter_params.ajaxurl,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('.fillter-list').css('display','none');
				$('.list-filter-selected').html('');
				$('.list-product').html('');
			},
			success : function( data ){
				if( data ) {
					$('.fillter-list').css('display','flex');
					list_selected.forEach(function(item_selected){
						$('.list-filter-selected').append('<span class="data-filter">'+item_selected+'</span>');
					});
					$('.list-product').html(data);	
				}
			}
		});
		return false;
	});
	
	$('.price-range').click(function(){
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
		var min_price = $(this).attr('data-min-price');
		var max_price = $(this).attr('data-max-price');
		if((typeof min_price !== 'undefined') && (typeof max_price !== 'undefined')){
		    $("input[name='min_price']").val(min_price);
		    $("input[name='max_price']").val(max_price);
		    
		    $(".woocommerce-ordering").submit();
		}
		return false;
	});
	
	$('.data-filter.filter-attr').click(function(){
		var id = $(this).data('term');
		$('li[data-term='+id+'] .a-click').trigger('click');
	});
	
	$('.clear-all').click(function(){
		var url = $(this).data('url');
		window.location.href = url;
	});
});